
(function trackableCollectionDefinition() {

    var trackableCollectionItemState = {
        Untouched: 0,
        Deleted: 1,
        Modified: 2,
        New: 3
    };

    angular.module('TrackableCollection')
        .factory('trackableCollection', function trackableCollectionFactory() {

            function isWrapped(item) {
                return !angular.isUndefined(item.__wrapped);
            }

            function unwrap(item) {
                if (isWrapped(item))
                    return item.item;
                return item;
            }

            function isEmpty() {

                if (this.find) {
                    return this.find(function (item) {
                        return item.state !== trackableCollectionItemState.Deleted;
                    }) == null;
                } else {
                    for (var i = 0; i < this.length; i++) {
                        if (this[i].state !== trackableCollectionItemState.Deleted) {
                            return false;
                        }
                    }
                }
                return true;
            }

            function add(item) {

                item = unwrap(item);
                var colItem = this.findItem(item);

                if (!this.hasId(item))
                    item.__newId = this.newItemId++;

                if (colItem !== null && !angular.isUndefined(colItem)) {
                    if (colItem.state === trackableCollectionItemState.Deleted) {
                        colItem.state = colItem.oldState;
                        this.appliedLength++;
                    } else if (!angular.equals(item, colItem.item)) {
                        colItem.state = trackableCollectionItemState.Modified;
                    }
                    colItem.item = item;
                } else {
                    this.appliedLength++;

                    colItem = {
                        item: item,
                        state: trackableCollectionItemState.New,
                        __wrapped: true
                    };

                    this.push(colItem);
                }

                return colItem;
            }

            function insert(item, index) {

                item = unwrap(item);

                // si en el mismo indice está el mismo item entonces solo modifico
                // el estado y su item
                if (this[index] !== null && !angular.isUndefined(this[index]) && this.compareFn(item, unwrap(this[index])) === true) {
                    if (this[index].state === trackableCollectionItemState.Deleted) {
                        this[index].state = this[index].oldState;
                        this.appliedLength++;
                    }
                    this[index].item = item;
                    return this[index];
                }
                this.appliedLength++;

                item = {
                    item: item,
                    state: trackableCollectionItemState.New,
                    __wrapped: true
                };

                if (index < 0) {
                    index = (this.length + index) + 1;
                } else if (index > this.length) {
                    index = this.length;
                }

                if (angular.isArray(item)) {
                    var items = [];
                    for (var i = 0; i < item.length; i++) {
                        items.push(this.insert(item[i], i));
                    }
                    return items;
                } else {
                    if (index !== undefined && index !== null && index < this.length)
                        this.splice(index, 0, item);
                    else
                        this.push(item);
                }

                return item;
            }

            function remove(item, preserveNew) {

                item = unwrap(item);
                var colItem = this.findItem(item);

                if (colItem) {
                    if (colItem.state === trackableCollectionItemState.New && !preserveNew) {
                        for (var i = 0; i < this.length; i++) {
                            if (this.compareFn(item, unwrap(this[i]))) {
                                this.splice(i, 1);
                                this.appliedLength--;
                                break;
                            }
                        }
                    } else {
                        if (colItem.state !== trackableCollectionItemState.Deleted) {
                            colItem.oldState = colItem.state;
                            colItem.state = trackableCollectionItemState.Deleted;
                            this.appliedLength--;
                        }
                    }
                    return true;
                }
                return false;
            }

            function isNew(item) {
                item = unwrap(item);
                var colItem = this.findItem(item);

                return (!colItem) || colItem.state === trackableCollectionItemState.New;
            }

            function removeAt(index) {
                var item = this[index];

                if (item !== null && !angular.isUndefined(item)) {
                    if (item.state === trackableCollectionItemState.New) {
                        this.splice(index, 1);
                        this.appliedLength--;
                    } else {
                        if (item.state !== trackableCollectionItemState.Deleted) {
                            item.oldState = item.state;
                            this.appliedLength--;
                        }
                        item.state = trackableCollectionItemState.Deleted;
                    }
                    return true;
                }
                return false;
            }

            function undoRemove(item) {

                if (!isWrapped(item)) {
                    // es un item plain, obtengo el de la collection
                    item = this.findItem(item);
                }

                if (item) {
                    item.state = item.oldState;
                    return true;
                }
                return false;
            }

            function save(item) {

                if (item) {
                    item = unwrap(item);
                    var colItem = this.findItem(item);

                    if (colItem && (!angular.equals(item, colItem.item)
                        || colItem.state === trackableCollectionItemState.Deleted)) {
                        if (colItem.state !== trackableCollectionItemState.New) {
                            if (item.state === trackableCollectionItemState.Deleted)
                                this.appliedLength++;
                            colItem.state = trackableCollectionItemState.Modified;
                        }
                        colItem.item = item;
                        return true;
                    }
                }
                return false;
            }

            function changed(item) {

                if (item) {
                    if (!isWrapped(item))
                        item = this.findItem(item);

                    if (item.state !== trackableCollectionItemState.New) {
                        if (item.state === trackableCollectionItemState.Deleted)
                            this.appliedLength++;
                        item.state = trackableCollectionItemState.Modified;
                    }
                }
                return item;
            }

            function findItem(conditionFn) {

                var compareFn = this.compareFn;

                if (!angular.isFunction(conditionFn)) {
                    // conditionFn es un item
                    var item = unwrap(conditionFn);
                    conditionFn = function (itm) {
                        return compareFn(itm, item);
                    };
                }

                if (this.find) {
                    return this.find(function (itm) {
                        return conditionFn(unwrap(itm));
                    });
                } else {
                    for (var i = 0; i < this.length; i++) {
                        if (conditionFn(unwrap(this[i]))) {
                            return this[i];
                        }
                    }
                }
                return null;
            }

            function contains(conditionFn, state, filterDeleted) {

                var compareFn = this.compareFn;

                if (!angular.isFunction(conditionFn)) {
                    // conditionFn es un item
                    var item = unwrap(conditionFn);
                    conditionFn = function (itm) {
                        return compareFn(itm, item);
                    };
                }

                for (var i = 0; i < this.length; i++) {
                    var itm = this[i];
                    if (!angular.isUndefined(state) && state !== null && itm.state !== state)
                        continue;
                    if (conditionFn(unwrap(itm))) {
                        return (!filterDeleted || (filterDeleted && itm.state !== trackableCollectionItemState.Deleted));
                    }
                }
                return false;
            }

            function applyFilter(conditionFn, state) {

                if (this.filter) {
                    return trackable(this.filter(function (itm) {
                        if (!angular.isUndefined(state) && itm.state !== state)
                            return false;
                        return conditionFn(unwrap(itm));
                    }));
                } else {
                    var ret = [];
                    for (var i = 0; i < this.length; i++) {
                        if (!angular.isUndefined(state) && itm.state !== state)
                            continue;
                        if (conditionFn(unwrap(itm))) {
                            ret.push(itm);
                        }
                    }
                    return trackable(ret);
                }

            }
            
            function clear(preserveNew) {

                var i = 0;
                while (i < this.length) {
                    var colItem = this[i];

                    if (colItem.state === trackableCollectionItemState.New && !preserveNew) {
                        this.splice(i, 1);
                        this.appliedLength--;
                    } else {
                        if (colItem.state !== trackableCollectionItemState.Deleted) {
                            colItem.oldState = colItem.state;
                            this.appliedLength--;
                        }
                        colItem.state = trackableCollectionItemState.Deleted;
                        i++;
                    }
                }

            }

            function commit() {

                var i = 0;
                while (i < this.length) {
                    var colItem = this[i];

                    if (colItem.state === trackableCollectionItemState.Deleted) {
                        this.splice(i, 1);
                    } else {
                        if (colItem.item.__newId !== undefined)
                            delete colItem.item.__newId;
                        colItem.state = trackableCollectionItemState.Untouched;
                        i++;
                    }
                }

            }

            function sortItems(comparer) {

                var fn = comparer ? function (a, b) {
                    return comparer(a.item, b.item)
                } : function (a, b) {
                    return a < b;
                };

                this.sort(fn);
            }

            function iterator(all) {

                var index = 0,
                    that = this;

                if (!all) {
                    while (index < this.length
                        && this[index].state == trackableCollectionItemState.Deleted) {
                        index++;
                    }
                }

                return {
                    // Avanza el iterador.
                    next: function () {
                        index++;
                        if (!all) {
                            while (index < that.length
                                && that[index].state == trackableCollectionItemState.Deleted) {
                                index++;
                            }
                        }
                    },
                    current: function () {
                        if (index < that.length)
                            return that[index].item;
                        return null;
                    },
                    currentFull: function () {
                        if (index < that.length)
                            return that[index];
                        return null;
                    },
                    hasValue: function () {
                        return (index < that.length);
                    }
                };
            }

            var trackable = function trackableCollection(collection, compareFn, hasId) {

                if (collection.__trackable)
                    return collection;

                if (hasId === undefined) {
                    hasId = function(item) {
                        return !(item.id === undefined);
                    }
                }

                if (compareFn === undefined) {
                    compareFn = function(item1, item2) {
                        if (item1.__newId !== undefined) {
                            return item1.__newId === item2.__newId;
                        }
                        return item1.id === item2.id;
                    };
                } else {
                    var fn = compareFn;
                    compareFn = function (item1, item2) {
                        if (item1.__newId !== undefined) {
                            return item1.__newId === item2.__newId;
                        }
                        return fn(item1, item2);
                    };
                }

                collection.compareFn = compareFn;
                collection.hasId = hasId;
                collection.newItemId = 0;   // se utilizará para asignar un id a los elementos nuevos.
                collection.isEmpty = isEmpty;
                collection.isNew = isNew;
                collection.add = add;
                collection.insert = insert;
                collection.remove = remove;
                collection.removeAt = removeAt;
                collection.undoRemove = undoRemove;
                collection.save = save;
                collection.changed = changed;
                collection.findItem = findItem;
                collection.contains = contains;
                collection.applyFilter = applyFilter;
                collection.clear = clear;
                collection.commit = commit;
                collection.sortItems = sortItems;
                collection.iterator = iterator;
                
                collection.__trackable = true;
                collection.appliedLength = 0;

                angular.forEach(collection, function wrapper(item) {
                    item.__wrapped = true;
                    if (item.state !== trackableCollectionItemState.Deleted) {
                        collection.appliedLength++;
                    }
                });

                return collection;
            };

            function fromArray(source) {

                var ret = trackable([]);
                var colItem = null;

                angular.forEach(source, function wrapper(item) {

                    if (!isWrapped(item)) {
                        colItem = {
                            item: item,
                            state: trackableCollectionItemState.New,
                            __wrapped: true
                        };
                    } else {
                        colItem = item;
                    }

                    ret.push(colItem);
                });

                ret.appliedLength = source.length;
                return ret;
            };

            trackable.states = trackableCollectionItemState;
            trackable.unwrap = unwrap;
            trackable.isWrapped = isWrapped;
            trackable.fromArray = fromArray;

            return trackable;
        });

})();
